import { render, staticRenderFns } from "./HomeMainWestudy.vue?vue&type=template&id=f4330ce4&scoped=true&"
import script from "./HomeMainWestudy.vue?vue&type=script&lang=js&"
export * from "./HomeMainWestudy.vue?vue&type=script&lang=js&"
import style0 from "./HomeMainWestudy.vue?vue&type=style&index=0&id=f4330ce4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4330ce4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
